<template>
  <div>
    <v-card class="rounded-lg" flat>
      <v-card-title class="px-10 pt-8">
        <p>{{ $t("organization.details.tabs.afrus_engine.title") }}</p>
      </v-card-title>
      <v-divider />
      <v-card-text class="ml-14">
        <div v-if="isUpdateLoading" class="d-flex justify-center align-center">
          <v-row no-gutters class="px-12 py-6">
            <v-col cols="12" class="d-flex justify-center align-center">
              <v-progress-circular
                indeterminate
                color="#2661FF"
                size="80"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <template v-for="item of computedGatewaysForAfrusEngine">
            <v-checkbox
              :label="item.name"
              v-model="item.afrus_engine_enabled"
              @change="
                updateAfrusEngine(
                  item.id,
                  item.afrus_engine_enabled,
                  item.api_keys
                )
              "
            >
            </v-checkbox>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "organizationAfrusEngine",
  data() {
    return {
      isUpdateLoading: false,
      afrus_engine_by_gateways: ["Niubiz"]
    };
  },
  computed: {
    ...mapState({
      organizationGateways: ({ organization: { organization } }) =>
        organization.gateways
    }),
    computedGatewaysForAfrusEngine() {
      const gateways = this.organizationGateways.filter(({ gateway }) =>
        this.afrus_engine_by_gateways.includes(gateway.name)
      );

      return gateways.map(({ gateway, api_keys }) => {
        return {
          id: gateway.id,
          name: gateway.name,
          afrus_engine_enabled: !!api_keys.afrus_engine,
          api_keys
        };
      });
    }
  },
  methods: {
    ...mapActions({
      updatePayments: "organization/updatePayments"
    }),
    async updateAfrusEngine(id, afrus_engine_new_status, api_keys) {
      try {
        this.isUpdateLoading = true;
        await this.updatePayments({
          orgId: this.orgId,
          gatewayId: id,
          data: {
            api_keys: {
              ...api_keys,
              afrus_engine: afrus_engine_new_status ? true : undefined
            }
          }
        });
      } catch (error) {
      } finally {
        this.isUpdateLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
